// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_edit_form":"form_mypage_subsc_edit_form__2PWjb","mypage_subsc_address_submit":"form_mypage_subsc_address_submit__1fv8l"};